import { Directive, HostBinding, HostListener, Input } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  ISortEventArgs,
  TSortColumn,
  TSortDirection,
} from '../classes/grid-page-info';

const rotate: Record<string, TSortDirection> = {
  ASC: 'DESC',
  DESC: 'ASC',
  '': 'ASC',
};

@Directive({
  selector: 'th[sortBy]',
})
export class NgbdSortableHeaderDirective {
  @Input() sortBy: TSortColumn = '';

  direction: TSortDirection;

  private _direction$: Subject<ISortEventArgs> = new Subject<ISortEventArgs>();

  @HostBinding('class.asc') get classAsc() {
    return this.direction === 'ASC';
  }
  @HostBinding('class.desc') get classDesc() {
    return this.direction === 'DESC';
  }

  @HostListener('click') onMouseEnter() {
    this.rotate();
  }

  rotate() {
    this.direction = rotate[this.direction || 'DESC'];
    this._direction$.next({ column: this.sortBy, direction: this.direction });
  }

  get direction$(): Observable<ISortEventArgs> {
    return this._direction$;
  }
}
